"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerContainer = exports.CardType = void 0;
var React = require("react");
var CountDown_1 = require("../CountDown");
var styled_1 = require("./styled");
var CardType;
(function (CardType) {
    CardType["Single"] = "Single";
    CardType["Normal"] = "Normal";
})(CardType = exports.CardType || (exports.CardType = {}));
exports.BannerContainer = function (props) {
    var _a = props.imgWidth, imgWidth = _a === void 0 ? "" : _a, _b = props.imgHeight, imgHeight = _b === void 0 ? "" : _b, _c = props.type, type = _c === void 0 ? CardType.Normal : _c, banner = props.banner, ltImg = props.ltImg, rtImg = props.rtImg, _d = props.countdownToEnd, countdownToEnd = _d === void 0 ? "0" : _d;
    return (React.createElement(styled_1.BannerWrapper, { type: type, imgWidth: imgWidth, imgHeight: imgHeight },
        ltImg && React.createElement("img", { className: "ltImg", src: ltImg }),
        rtImg && React.createElement("img", { className: "rtImg", src: rtImg }),
        +countdownToEnd > 0 && (React.createElement("div", { className: "countdown" },
            React.createElement(CountDown_1.default, { countTime: countdownToEnd, style: {
                    borderRadius: type === CardType.Single ? "0 0 0 6px" : undefined
                }, needIcon: type !== CardType.Single }))),
        React.createElement("img", { className: "mainImg", src: banner })));
};
